import { metaPath } from 'util/metaPath'

import { MotivoConsultaFormModel } from './motivo-consulta/MotivoConsultaForm'

export interface EscutaInicialState {
  lastSaved?: Date
  motivoConsulta?: MotivoConsultaFormModel
  openedAccordions?: (string | number)[]
}

export const name = metaPath<EscutaInicialState>()

export const initialValue = (): Partial<EscutaInicialState> => ({
  openedAccordions: ['D'],
  lastSaved: new Date(),
})
